<template>
  <div>
    <Headersys />
    <div class="content">
      <!-- 头 -->
      <BsznCurrent :steps="1" @getSXFL="getSXFL" />
      <div class="section-box">
        <div class="section-card" v-for="item in paginatedData" :key="item.id" @click="chooseTab(item)">
          <div class="section-num">{{ item.idx }}</div>
          <div class="section-title">{{ item.NAME }}</div>
        </div>
      </div>
      <PageSize :total="sectionList.length" :totalPages="totalPages" :currentPage="currentPage"
        @currentChange="currentChange" />
      <Back />
    </div>
    <div class="iframe-mask" v-if="iframeOpen">
      <div class="iframe-box">
        <div class="iframe-title">{{ iframeTitle }}</div>
        <iframe id="myIframe" class="iframe-body" :src="iframeUrl" frameborder="0"></iframe>
        <div class="iframe-btnbox">
          <div class="btn-ifm" @click="iframeOpen = false">返 回</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //
      sectionList: [],//部门列表
      pageSize: 6,
      currentPage: 1,
      iframeOpen: false,
      iframeTitle: '',
      iframeUrl: '',
      waitTime: 180,
      watiTimer: null,
      FLlist: []
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.sectionList.length / this.pageSize);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.sectionList.slice(startIndex, endIndex);
    },
  },
  created() {
    //
    this.getSX()
  },
  mounted() {
    //
    this.timeDown()
  },
  destroyed() {
    // console.log('页面销毁');
    clearTimeout(this.watiTimer);
  },
  methods: {
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 180
          clearInterval(this.watiTimer)
          this.$router.replace('/')
        }
      }, 1000);
    },
    chooseTab(item) {
      this.$router.push({
        path: '/zndetails',
        query: {
          code: item.CODE
        }
      })
      // this.iframeTitle = item.NAME
      // this.iframeUrl = `http://wfzwfw.sd.gov.cn/wf/icity/proinfo/index?code=${item.CODE}`
      // this.iframeOpen = true
    },
    //获取部门列表
    getSX() {
      this.$rqt.division_sendUrl({
        url: 'getItemList',
        params: {
          orgCode: this.$route.query.code,
          regionCode: '370705000000',
        }
      }).then(res => {
        this.sectionList = JSON.parse(res.data).data
        this.sectionList.forEach((el, idx) => {
          el.idx = idx + 1
        })
        this.FLlist = JSON.parse(JSON.stringify(this.sectionList))
        // console.log(this.FLlist);
      }).catch(() => {
        // 浪潮接口获取事项列表失败
        this.getSXZS()
      })
    },
    //中盛获取事项列表
    getSXZS() {
      this.$rqt.bfMaster_getOrgCodeGetMaster({
        orgCode: this.$route.query.code,
        current: 1,
        size: 10000
      }).then(res => {
        this.FLlist = []
        res.data.records.forEach((el, idx) => {
          if (el.type == '01' || el.type == '07' || el.type == '10' || el.type == '20') {
            el.idx = idx + 1
            this.FLlist.push(el)
          }
        })
        this.sectionList = JSON.parse(JSON.stringify(this.FLlist))
      })
    },
    currentChange(num) {
      if (num == -1) {
        if (this.currentPage == 1) {
          return
        }
        this.currentPage--
      } else if (num == -2) {
        if (this.currentPage == this.totalPages) {
          return
        }
        this.currentPage++
      } else {
        this.currentPage = num
      }
    },
    getSXFL(keyWord) {
      // console.log(keyWord);
      var arr = []
      this.FLlist.forEach(el => {
        if (el.NAME.includes(keyWord)) {
          arr.push(el)
        }
      })
      if (arr.length) {
        this.sectionList = arr
      } else {
        this.sectionList = this.FLlist
      }
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  padding: 0 5rem;
  background-color: #F1FAFC;
}

.section-box {
  // display: flex;
  // align-items: center;
  // flex-wrap: wrap;
  // justify-content: space-between;

  .section-card {
    // width: 98%;
    display: flex;
    align-items: center;
    // border: 1px solid rgba($color: #000000, $alpha: .1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 1rem;
    margin-bottom: 3rem;
    background-color: #fff;

    .section-num {
      width: 12rem;
      height: 12rem;
      line-height: 12rem;
      font-size: 6rem;
      text-align: center;
      color: #fff;
      background-color: #0099FF;
      border-radius: 1rem 0 0 1rem;
      margin-right: 5rem;
    }

    .section-title {
      width: calc(100% - 13rem);
      font-size: 5rem;
    }
  }
}


.iframe-mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .iframe-box {
    width: 80%;
    // height: 80vh;
    background-color: #fff;
    border-radius: 5rem;
  }

  .iframe-title {
    background-color: #0099FF;
    color: #ffffff;
    font-size: 8rem;
    padding: 3rem;
    text-align: center;
    border-radius: 5rem 5rem 0 0;
  }

  .iframe-body {
    width: 100%;
    height: 70vh;
  }

  // .iframe-body::-webkit-scrollbar {
  //   width: 0px;
  //   height: 0px;
  // }

  .iframe-btnbox {
    // width: 1000px;
    width: 100%;
    // height: 10rem;
    padding: 2rem 0;
    text-align: center;
    background-color: #ffffff;
    border-radius: 0 0 5rem 5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-ifm {
      font-size: 6rem;
      padding: 3rem 8rem;
      font-weight: bold;
      border-radius: 2rem;
      color: #ffffff;
      background-color: #4FA8FF;
    }
  }
}
</style>